import { UserModel, RoleModel, UserVisitModel } from './../definition/system.model';
import { Injectable, Injector } from '@angular/core';
import { ReplaySubject, BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GenericApiService } from 'shared/services';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserApiService extends GenericApiService<UserModel, any> {

  constructor(injector: Injector) {
    super(injector, "user");

  }

  getUserRole(id: string) {
    return this.httpClient.get<RoleModel[]>(this.apiUrl + `/userole/${id}`);
  }

  getRoles(id: string) {
    return this.httpClient.get<string[]>(`${this.apiUrl}/${id}/roles`);
  }

  // 层级管理拖拽人员时更新其 ProjectId
  updateProjectId(id: string, projectId: string) {
    return this.httpClient.put(`${this.apiUrl}/${id}/${projectId}/updateProjectId`, null);
  }
  
  getByProjectId(projectId: string) {
    return this.httpClient.get<UserModel[]>(`${this.apiUrl}/${projectId}/getbyprojectid`);
  }

  getAssignUsers() {
    return this.httpClient.get<UserModel[]>(this.apiUrl + `/getAssignUsers`);
  }

  getCurrent() {
    return this.httpClient.get<UserModel>(this.apiUrl + `/current`);
  }
  //更新用户最近登录时间
  updateLastLoginTime(userId: string) {
    return this.httpClient.put(`${this.apiUrl}/UpdateLastLoginTime/${userId}`, null);
  }

  //获取最近登录的用户
  getLastLoginUsers() {
    return this.httpClient.get<UserVisitModel[]>(`${this.apiUrl}/GetLastLoginUsers`);
  }
}